import { get } from 'lodash';
import { uuid } from '@/utils';
import * as SettleApi from '@/api/bill/settle';
import * as OrderApi from '@/api/order';
import actionTypes from './actionType';

const toggleSettleDrawerVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_SETTLE_DRAWER_VISIBLE,
    payload: {
      drawerVisible: visible,
    },
  };
};

const setOrderStateLoading = (loading) => {
  return {
    type: actionTypes.SET_ORDER_STATE_LOADING,
    payload: {
      orderStateLoading: loading,
    },
  };
};

const initOrderState = (params) => {
  return async (dispatch) => {
    dispatch(setOrderStateLoading(true));
    try {
      const res = await OrderApi.fetchOrderDetailBaseInfo(params);
      dispatch(setOrderStateLoading(false));
      dispatch({
        type: actionTypes.INIT_ORDER_STATE,
        payload: {
          orderState: get(res, 'data.resvStatus', 0),
        },
      });
    } catch (err) {
      dispatch(setOrderStateLoading(false));
    }
  };
};

const setOrderState = (state) => {
  return {
    type: actionTypes.SET_ORDER_STATE,
    payload: {
      orderState: state,
    },
  };
};

const setSettleStep = (step) => {
  return {
    type: actionTypes.SET_SETTLE_STEP,
    payload: {
      step,
    },
  };
};

const setOrderInfoLoading = (loading) => {
  return {
    type: actionTypes.SET_ORDER_INFO_LOADING,
    payload: {
      orderInfoLoading: loading,
    },
  };
};

const initOrderInfo = (params) => {
  return async (dispatch) => {
    dispatch(setOrderInfoLoading(true));
    try {
      const res = await SettleApi.fetchOrderInfo(params);
      dispatch(setOrderInfoLoading(false));
      // 应收加收超时房费赋初始值
      let checkOutRoomList = get(res, 'data.checkOutRoomList', []);
      checkOutRoomList = checkOutRoomList?.map((item) => {
        return {
          ...item,
          overtimePriceReceivable: get(item, 'overtimePrice', 0),
        };
      });
      const cancelReservationList = get(res, 'data.cancelReservationList', []);
      dispatch({
        type: actionTypes.FETCH_ORDER_INFO,
        payload: {
          orderInfo: {
            cancelReservationList,
            checkOutRoomList,
            overtimePriceAdjustList: [],
          },
        },
      });
    } catch (err) {
      dispatch(setOrderInfoLoading(false));
    }
  };
};

const updateOrderInfo = (params) => {
  const { orderInfo } = params;
  const { cancelReservationList, checkOutRoomList } = orderInfo;

  // 获取加收超时房费冲调列表 有几个“[实际加收超时房费] ＜ [应加收超时房费]”的场景，这里就出现几条对应的记录
  const adjustList = [];
  (checkOutRoomList || [])?.forEach((item) => {
    if (Number(item?.overtimePrice) - Number(item?.overtimePriceReceivable) < 0) {
      adjustList.push({
        ...item,
        adjustPrice: `-${Number(item?.overtimePriceReceivable) - Number(item?.overtimePrice)}`,
        indexId: uuid(),
      });
    }
  });

  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_ORDER_INFO,
      payload: {
        orderInfo: {
          cancelReservationList,
          checkOutRoomList,
          overtimePriceAdjustList: adjustList,
        },
      },
    });
  };
};

const updateAdjustRecordChange = (indexId: string, updateValue) => {
  return (dispatch, getState) => {
    const { orderInfo } = getState().settle;
    const { overtimePriceAdjustList } = orderInfo;
    dispatch({
      type: actionTypes.UPDATE_ORDER_INFO,
      payload: {
        orderInfo: {
          ...orderInfo,
          overtimePriceAdjustList: overtimePriceAdjustList?.map((item) => {
            if (item.indexId === indexId) {
              return {
                ...item,
                ...updateValue,
              };
            }
            return item;
          }),
        },
      },
    });
  };
};

const resetOrderInfo = () => {
  return {
    type: actionTypes.RESET_ORDER_INFO,
    payload: {},
  };
};

const setCheckRoomListLoading = (loading) => {
  return {
    type: actionTypes.SET_CHECK_ROOM_LIST_LOADING,
    payload: {
      checkRoomListLoading: loading,
    },
  };
};

const initCheckRoomList = (params) => {
  return async (dispatch) => {
    dispatch(setCheckRoomListLoading(true));
    try {
      const res = await SettleApi.fetchCheckRoomList(params);
      dispatch(setCheckRoomListLoading(false));
      dispatch({
        type: actionTypes.FETCH_CHECK_ROOM_LIST,
        payload: {
          checkRoomList: get(res, 'data', {}),
        },
      });
    } catch (err) {
      dispatch(setCheckRoomListLoading(false));
    }
  };
};

const setSettleInfoLoading = (loading) => {
  return {
    type: actionTypes.SET_SETTLE_INFO_LOADING,
    payload: {
      settleInfoLoading: loading,
    },
  };
};

const initSettleInfo = (params) => {
  return async (dispatch) => {
    dispatch(setSettleInfoLoading(true));
    try {
      const res = await SettleApi.fetchSettleInfo(params);
      dispatch(setSettleInfoLoading(false));
      dispatch({
        type: actionTypes.FETCH_SETTLE_INFO,
        payload: {
          settleInfo: get(res, 'data', {}),
        },
      });
    } catch (err) {
      dispatch(setSettleInfoLoading(false));
    }
  };
};

const toggleOverStayModalVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_OVERSTAY_MODAL_VISIBLE,
    payload: {
      overStayModalVisible: visible,
    },
  };
};

const setOverStayListLoading = (loading) => {
  return {
    type: actionTypes.SET_OVERSTAY_LIST_LOADING,
    payload: {
      overStayListLoading: loading,
    },
  };
};

const initOverStayList = (params) => {
  return async (dispatch) => {
    dispatch(setOverStayListLoading(true));
    try {
      const res = await SettleApi.fetchOverStayInfo(params);
      dispatch(setOverStayListLoading(false));
      dispatch({
        type: actionTypes.INIT_OVERSTAY_LIST,
        payload: {
          overStayList: get(res, 'data', {}),
        },
      });
    } catch (err) {
      dispatch(setOverStayListLoading(false));
    }
  };
};

const updateOverStayList = (list) => {
  return {
    type: actionTypes.UPDATE_OVERSTAY_LIST,
    payload: {
      overStayList: list,
    },
  };
};

export {
  toggleSettleDrawerVisible,
  initOrderState,
  setOrderState,
  setSettleStep,
  initOrderInfo,
  updateOrderInfo,
  resetOrderInfo,
  initCheckRoomList,
  initSettleInfo,
  toggleOverStayModalVisible,
  initOverStayList,
  updateOverStayList,
  updateAdjustRecordChange,
};
